import React from "react";

export const LOGO_URL =
  "https://storageaccountzampl852f.blob.core.windows.net/zamplia-survey-images/surveyLogo.png";

/** Product logo; `.zs-logo` renders it monochrome-light in dark mode. */
export const BrandLogo = ({ className = "h-8 w-auto" }: { className?: string }) => (
  <img src={LOGO_URL} alt="Zamplia Surveys" className={`zs-logo ${className}`} />
);
